export default {
  email: "FOOTER.email",
  customerCareNumber: "FOOTER.customerCareNumber",
  copyright: "FOOTER.copyright",
  companyAddress: "FOOTER.companyAddress",
  companyLogo: "FOOTER.companyLogo",
  companyLogoAlt: "FOOTER.companyLogoAlt",
  companyUrl: "FOOTER.companyUrl",
};
